"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationMapper = void 0;
class OrganizationMapper {
    toOrganization(organizationResource) {
        return {
            id: organizationResource.id,
            createdAt: new Date(organizationResource.attributes.createdAt),
            updatedAt: new Date(organizationResource.attributes.updatedAt),
            name: organizationResource.attributes.name,
        };
    }
    toOrganizationResource(organization) {
        return {
            id: organization.id,
            type: 'Organization',
            attributes: {
                createdAt: organization.createdAt.toISOString(),
                updatedAt: organization.updatedAt.toISOString(),
                name: organization.name,
            },
        };
    }
    toOrganizationCreation(organizationCreationResource) {
        return {
            name: organizationCreationResource.attributes.name,
        };
    }
    toOrganizationCreationResource(organizationCreation) {
        return {
            type: 'Organization',
            attributes: {
                name: organizationCreation.name,
            },
        };
    }
    toOrganizationUpdate(organizationUpdateResource) {
        return {
            id: organizationUpdateResource.id,
            name: organizationUpdateResource.attributes.name,
        };
    }
    toOrganizationUpdateResource(organizationUpdate) {
        return {
            id: organizationUpdate.id,
            type: 'Organization',
            attributes: {
                name: organizationUpdate.name,
            },
        };
    }
}
exports.OrganizationMapper = OrganizationMapper;
//# sourceMappingURL=#organization-mapper.js.map